import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Box, Typography, Checkbox, FormControlLabel, TextField } from '@mui/material'
import { useStyles } from './style'
import { SITE_STATUS } from './constants'
import { AppButton } from '../../components'
import Icon from '../../utils/icons'
import { PROGRAM_KEY, FAMILY_KEY } from '../../constants/common'
import { removeNonAsciiChars } from '../../utils/common'

function ApplicationFooter(props) {
  const classes = useStyles()
  const referenceId = props.programKey === PROGRAM_KEY.PSEG_LI ? _.get(props.applicationDetails, 'utility_reference_id', '') : ''
  const [psegUploaded, setPsegUploaded] = useState(false)

  useEffect(() => {
    setPsegUploaded(false)
    props.setPsegReferenceId('')
  }, [props.applicationId, props.length])

  const renderText = () => {
    if (props.applicationStatus === SITE_STATUS.SITE_APPROVED || props.applicationStatus === SITE_STATUS.SITE_REJECTED || props.applicationStatus === SITE_STATUS.APPLICATION_REJECTED || props.applicationStatus === SITE_STATUS.APPLICATION_APPROVED) {
      return 'All Fields Validated'
    }

    return props.length === -1 ? 'All fields validation pending' : props.length === 0 ? 'All Fields Validated' : `Validation of ${props.length} field pending`
  }

  const handleCheckChange = (e, checked) => {
    setPsegUploaded(checked)
  }

  const handleOnchange = (e) => {
    let id = removeNonAsciiChars(e.target.value)
    id = id.slice(0, 12)
    props.setPsegReferenceId(id)
  }

  const isValidReferenceID = () => {
    let val = props.psegReferenceId
    val = val ? val.trim() : ''
    return val.length > 1
  }

  const isValid = () => {
    if (props.programKey === PROGRAM_KEY.PSEG_LI) {
      return props.applicationStatus === SITE_STATUS.APPLICATION_SUBMITTED ? !props.disableButton && isValidReferenceID() : true
    }

    return !props.disableButton
  }

  const renderFooterText = () => {
    if (props.applicationStatus === SITE_STATUS.APPLICATION_UNENROLLED) {
      return 'Application has been unenrolled'
    }
    if (props.programKey === PROGRAM_KEY.PSEG_LI) {
      switch (props.applicationStatus) {
        case SITE_STATUS.APPLICATION_REJECTED: return 'The Application has been rejected by Enphase'
        case SITE_STATUS.SITE_APPROVED: return 'The Application has been approved by PSEG'
        case SITE_STATUS.SITE_REJECTED: return 'The Application has been rejected by PSEG'
        default: return
      }
    }
    if (props.familyKey === FAMILY_KEY.CT_ESS) {
      switch (props.applicationStatus) {
        case SITE_STATUS.APPLICATION_APPROVED: return 'The Application has been approved by Enphase'
        case SITE_STATUS.APPLICATION_REJECTED: return 'The Application has been rejected by Enphase'
        case SITE_STATUS.SITE_APPROVED: return 'The Application has been approved by Utility'
        case SITE_STATUS.SITE_REJECTED: return 'The Application has been rejected by Utility'
        default: return
      }
    }
    if (props.programKey === PROGRAM_KEY.GMP_ENPH || props.programKey === PROGRAM_KEY.APS_RBP) {
      return props.applicationStatus === SITE_STATUS.SITE_APPROVED ? 'The Application has been Approved' : 'The Application has been Rejected'
    }
    return props.applicationStatus === SITE_STATUS.APPLICATION_APPROVED ? 'The Application has been Approved' : 'The Application has been Rejected'
  }

  return (
    <Box className={classes.footer}>
      {props.applicationStatus === SITE_STATUS.APPLICATION_UNENROLLED && 
        <Box className={`${classes.statusTextWrapper} ${classes.statusWrapper}`}>
          <Box className={`${classes.footerDot} ${classes.dotColor}`} />
          <Box className={classes.statusText}>{renderFooterText()}</Box>
        </Box>
      }
      {props.applicationStatus !== SITE_STATUS.APPLICATION_UNENROLLED &&
      <>
        <Typography className={classes.validationText}>{renderText()}</Typography>
        <Box>
          {props.programKey === PROGRAM_KEY.PSEG_LI && !props.disableButton &&
            <Box>
              <FormControlLabel
                control={<Checkbox />}
                label="I have uploaded PSEG Enrolment Form on PSEG Portal."
                onChange={handleCheckChange}
              />
              {!psegUploaded
                ?
                <Typography>
                  <span className={classes.footerLink}>Not uploaded yet?</span>
                  <a target="_blank" href="https://admin.energyhub.net/"><span className={classes.link}>Visit PSEG Portal ></span></a>
                </Typography>
                : (
                  <Box>
                    <TextField
                      id="reference_id"
                      label="Enter PSEG Reference ID"
                      variant="standard"
                      onChange={handleOnchange}
                      value={props.psegReferenceId}
                      error={props.psegReferenceId ? !isValidReferenceID() : false}
                      helperText={props.psegReferenceId ? !isValidReferenceID() ? 'Enter Valid Reference ID' : '' : ''}
                      InputProps={{
                        classes: { root: classes.inputRoot },
                        endAdornment: props.psegReferenceId ? (isValidReferenceID() ? <Icon src="circleTick" /> : <Icon src="circleCross" />) : ''
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }} />
                  </Box>
                )
              }
            </Box>
          }
          {
            props.programKey === PROGRAM_KEY.PSEG_LI && (props.applicationStatus === SITE_STATUS.APPLICATION_APPROVED || props.applicationStatus === SITE_STATUS.SITE_REJECTED || props.applicationStatus === SITE_STATUS.SITE_APPROVED) &&
            (
              <Box>
                <Typography className={classes.formUploadedWrapper}>
                  <Icon src="circleTick" />
                  <span className={classes.formUploaded}>PSEG Enrolment Form uploaded on PSEG Portal</span>
                </Typography>
                <Box className={classes.referenceIdWrapper}>
                  <Typography className={classes.referenceLabel}>PSEG Reference ID</Typography>
                  <Typography className={classes.referenceId}>{referenceId}</Typography>
                </Box>
              </Box>
            )
          }
          {
            props.applicationStatus === SITE_STATUS.APPLICATION_SUBMITTED || props.applicationStatus === SITE_STATUS.SITE_SUBMITTED || (props.applicationStatus === SITE_STATUS.APPLICATION_APPROVED && props.programKey === PROGRAM_KEY.PSEG_LI)
              ? (
                <Box className={classes.buttonWrapper} style={{ width: 'auto' }}>
                  <AppButton className={`${classes.button} ${classes.approveButton} ${props.programKey === PROGRAM_KEY.PSEG_LI ? classes.largeButton : ''}`} text={props.programKey === PROGRAM_KEY.PSEG_LI ? props.applicationStatus === SITE_STATUS.APPLICATION_SUBMITTED ? 'Provide Enphase Approval' : 'Provide PSEG Approval' : "Approve"} disabled={!isValid()} onClick={() => props.setApproveModal(true)} />
                  <AppButton className={`${classes.button} ${classes.rejectButton} ${props.programKey === PROGRAM_KEY.PSEG_LI ? classes.largeButton : ''}`} fill={false} text="Reject" onClick={() => props.setRejectModal(true)} />
                </Box>
              ) :
              (<Box className={classes.statusTextWrapper}>
                {props.applicationStatus === SITE_STATUS.SITE_APPROVED || props.applicationStatus === SITE_STATUS.APPLICATION_APPROVED ? <Icon src="circleTick" /> : <Icon src="circleCross" />}
                <Typography className={classes.statusText}>{renderFooterText()}</Typography>
                {(props.applicationStatus === SITE_STATUS.SITE_REJECTED || props.applicationStatus === SITE_STATUS.APPLICATION_REJECTED) && <Typography className={classes.showReason} onClick={() => props.setShowReason(true)}>(Show Reason)</Typography>}
              </Box>)
          }
        </Box>
      </>}
    </Box >
  )
}

ApplicationFooter.defaultProps = {
  length: -1,
  familyKey: ''
}

export default ApplicationFooter